var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.4769H13V19.697H11V13.4769H5V11.4035H11V5.18335H13V11.4035H19V13.4769Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconGreen);
export default __webpack_public_path__ + "static/media/add-icon-green.9e4a7148c416fddf877e8d33feac756f.svg";
export { ForwardRef as ReactComponent };